import Paragraph from "@/components/common/Typography/Paragraph"
import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { getValidDayjs } from "@/utils/safeParse/getValidDayjs"
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Card } from "antd"

const NewsItem = ({ blog }: any) => {
  return (
    <Card
      hoverable
      cover={
        <div
          style={{
            height: "180px",
            overflow: "hidden",
          }}
        >
          <img
            alt={blog.title}
            src={blog.thumbnail_url}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease",
            }}
          />
        </div>
      }
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        border: "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
        height: "320px",
      }}
      styles={{
        body: {
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          height: "140px",
        }
      }}
    >
      <div style={{ marginBottom: "0.5rem" }}>
        <Text type="secondary" style={{ fontSize: "11px" }}>
          <FontAwesomeIcon
            icon={faCalendarAlt}
            style={{ marginRight: "4px" }}
          />
          {getValidDayjs(blog.created_at).format("DD/MM/YYYY")}
        </Text>
      </div>

      <Title
        level={5}
        style={{
          margin: 0,
          marginBottom: "0.5rem",
          fontSize: "1.1rem",
          lineHeight: "1.3",
          color: "#262626",
          fontWeight: "600",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          height: "2.6rem",
        }}
      >
        {blog.title}
      </Title>

      <Paragraph
        style={{
          margin: 0,
          color: "#666",
          fontSize: "12px",
          lineHeight: "1.4",
          display: "-webkit-box",
          WebkitLineClamp: 1,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: 1,
        }}
      >
        {blog.summary}
      </Paragraph>
    </Card>
  )
}

export default NewsItem